import { render } from "./TokenPaymentSuccess.vue?vue&type=template&id=7ecfa8c2&scoped=true"
import script from "./TokenPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./TokenPaymentSuccess.vue?vue&type=script&lang=js"

import "./TokenPaymentSuccess.vue?vue&type=style&index=0&id=7ecfa8c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecfa8c2"]])

export default __exports__